// @flow
import { useCallback, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { api } from 'app/api';
import { GET_GRADES_AVERAGE, convertResult, convertParams } from 'app/common/api/requests/cabinet/dnevnik/grades/average';
import type { Params, AverageMarks } from 'app/dataTypes/AverageMarks.types';


export default function useAverageMarks({ klassId, studentId, date }: Params): AverageMarks {
  const { t } = useTranslation('app');
  const [averageMarks, setMarks] = useState<AverageMarks>({});

  const request = useCallback(async () => {
    const res = await api.request(GET_GRADES_AVERAGE, {
      error: t('request_dnevnik_marks_failed'),
      params: { klassId, studentId, date },
      convertions: { convertParams, convertResult },
    });
    if (res) {
      setMarks(res);
    }
  }, [klassId, studentId, date, t]);

  useEffect(() => {
    request();
  }, [request]);

  return averageMarks;
}
